'use strict';

import React, { useState, useEffect, Fragment, useRef } from 'react';
import uniqid from 'uniqid';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { URL, action } from 'Shared/Routes';
import GLOBAL_CONFIG from 'Shared/config';
import { FRONT_ENV } from 'front_env';
const API_URL = FRONT_ENV !== 'prod' ? 'https://web2payuat.3cint.com/' // sandbox
: 'https://web2pay.3cint.com/'; // prod

const SITE_URL = FRONT_ENV !== 'prod' ? GLOBAL_CONFIG.dev_url : window.location.protocol + '//' + window.location.host + '/';
export default function PlanetiPageKit(props) {
  const [loading, setLoading] = useState(false);
  const [display_iframe, setIframeVisible] = useState(false);
  const [iPage, setiPage] = useState();
  const [status, setStatus] = useState({});
  const [payment_error, setPaymentError] = useState();
  const [form_ref, setFormRef] = useState(null);
  useEffect(() => {
    getiPage();
  }, [props.id]); // on mount

  useEffect(() => {
    window.requestAnimationFrame(function () {
      const form = document.querySelector('form[target="planet_iPage_form"]');
      if (iPage && form) displayPayment();
    });
  }, [form_ref]);
  const loader = loading === true ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['primary', 'bg-white'],
    text: "Chargement..."
  }) : undefined;
  const output = /*#__PURE__*/React.createElement("div", {
    className: bemit('c-payment-kit', ['planet', 'i-page'])
  }, loader, getFormStatus(status), payment_error ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['v2', 'red'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, payment_error)) : undefined, iPage ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
    action: iPage.url,
    method: "POST",
    target: "planet_iPage_form",
    className: "c-payment-kit__iframe-form",
    ref: ref => setFormRef(ref),
    key: iPage.key + 'form'
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "XXX_IPGSESSION_XXX",
    value: iPage.token
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "redirect_approved",
    value: iPage.approved
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "redirect_declined",
    value: iPage.declined
  })), /*#__PURE__*/React.createElement("iframe", {
    className: 'c-payment-kit__iframe' + (display_iframe ? ' is-visible' : ''),
    name: "planet_iPage_form",
    src: "",
    onLoad: e => handleIframeChange(e)
  })) : undefined);
  return output;
  async function getiPage() {
    if (!props.id) return;
    setLoading(true);
    try {
      var response = await ajaxRequest(action('GetPlanetiPageToken'), {
        data: {
          id: props.id
        },
        timeout: 16 * 1000
      });
    } catch (e) {
      setLoading(false);
      console.error(e);
      return setStatus(e);
    }
    setLoading(false);
    setiPage({
      token: response.token,
      url: API_URL + 'iPage/Service/_2006_05_v1_0_1/service.aspx',
      approved: SITE_URL.slice(0, -1) + URL('IframeLoaderOK'),
      declined: SITE_URL.slice(0, -1) + URL('IframeLoaderKO'),
      key: uniqid()
    });
  }
  function displayPayment(e) {
    setLoading(true);
    const form = document.querySelector('form[action="' + iPage.url + '"]');
    form?.submit?.();
    setIframeVisible(true);
    window.setTimeout(function () {
      setLoading(false);
    }, 600);
  }
  function handleIframeChange(e, forced) {
    e?.persist?.();
    try {
      var params = e.target?.contentWindow;
      var url = [params.location?.origin, params.location?.pathname].filter(str => str).join('');
    } catch (e) {
      if (forced) return;
      return window.setTimeout(function () {
        handleIframeChange(e, true);
      }, 320);
    }
    if (url === iPage.declined) {
      setPaymentError('Le paiement a échoué. Vérifiez les informations de votre carte et réessayez.');
      getiPage();
    } else if (url === iPage.approved) {
      document.location.href = SITE_URL.slice(0, -1) + URL('PlanetPaymentRedirectOK');
    }
  }
}
